import { shell } from '../app';
import { h } from './dom';

/** Hand a file to the phone: the OS share sheet when it takes files, else a download (M5, D37).
 *  Extracted from the Reports export so the activity log hands over the same way. */
export const exportFile = async (
  filename: string,
  text: string,
  type = 'text/csv',
): Promise<'shared' | 'downloaded' | 'cancelled'> => {
  const file = new File([text], filename, { type });
  if (typeof navigator.canShare === 'function' && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: filename });
      return 'shared';
    } catch (err) {
      if ((err as Error).name === 'AbortError') return 'cancelled'; // user closed the sheet
      // fall through to download
    }
  }
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = h('a', { href: url, download: filename });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
  shell.toast(`${filename} downloaded`, { kind: 'success' });
  return 'downloaded';
};
